// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgResultIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="M12 .95c-4.96 0-9 4.04-9 9 0 7.47 8.12 12.63 8.47 12.85a1.01 1.01 0 0 0 1.06 0c.35-.22 8.47-5.38 8.47-12.85 0-4.96-4.04-9-9-9m4.59 10.91-.64.38c-.39.23-.8.42-1.23.55-.66.2-1.36.28-2.06.22-.84-.07-1.68.1-2.43.5s1.21 3.72 1.21 3.72a.56.56 0 0 1-.45.73.56.56 0 0 1-.62-.38l-3.2-9.83c-.1-.3.07-.62.36-.71.3-.1.62.07.71.36l.06.2c.92-.47 1.94-.68 2.97-.59.92.08 1.82-.13 2.61-.6l.64-.38c.15-.09.33-.11.49-.04.16.06.29.2.34.36l1.49 4.88c.08.25-.03.52-.25.65Z" />
  </Icon>
);
export default SvgResultIcon;
SvgResultIcon.displayName = 'SvgResultIcon';
